/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';

import styled from 'styled-components';
import styles from '../../styles';

import QuickFind from '../../../shared/components/QuickFind';
import LinkStyle from '../Link';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  padding: 0 1rem 1rem;

  @media (max-width: 767px) {
    flex-wrap: wrap;
    padding: 1.25rem;
  }
`;

const Text = styled.div`
  flex: 0 0 auto;
  ${styles.fonts.baseSmall}

  @media (max-width: 767px) {
    width: 100%;
    margin-bottom: 1rem;
  }
`;

export const ControlLinks = styled.div`
  flex: 0 0 auto;
  margin-left: auto;
  padding-right: 0.5rem;

  @media (max-width: 767px) {
    width: 100%;
    order: 3;
  }
`;

const StyledQuickFind = styled(QuickFind)`
  flex: 0 0 auto;

  @media (max-width: 767px) {
    width: 100%;
    margin-bottom: 1rem;
  }
`;

const BucktedDataTableControls = ({
  text, collapseAll, expandAll, onChange, className
}) => {
  return (
    <Wrapper className={className}>
      <Text>
        {text}
      </Text>
      <ControlLinks>
        <LinkStyle onClick={() => {
          expandAll();
        }}>Expand All</LinkStyle>
        <span>&nbsp;|&nbsp;</span>
        <LinkStyle onClick={() => {
          collapseAll();
        }}>Collapse All</LinkStyle>&nbsp;
      </ControlLinks>
      <StyledQuickFind onChange={onChange} />
    </Wrapper>
  );
};

export default BucktedDataTableControls;
